import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "../../styles.css"

const TableCell = ({ children, className, ...props }) => {
  const tableCellClass = classnames(styles.tableCellClass, className)
  return (
    <td {...props} className={tableCellClass}>
      {children}
    </td>
  )
}

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
export default TableCell



// WEBPACK FOOTER //
// ./src/components/Table/components/TableCell/index.js